<template>
    <div class="product-card_x">
        <img :src="product.img_url" :alt="product.name" />
        <span class="badge">Hot</span>

        <!-- <span class="product-catagory">{{product.category}}</span> -->
        <h3>{{ product.name }}</h3>
        <p>{{ product.description }}-</p>
        <div class="price-container">
            <span class="price-section">
                <p>
                    MRP: ₹
                    <span class="strikethrough">{{
                        product.price.toLocaleString()
                    }}</span>
                </p>
                <p class="price">
                    ₹ {{ product.offer_price.toLocaleString() }}
                    <span class="discount">{{ discountPercentage }}% off</span>
                </p>
            </span>
            <button @click="openStoreURL">Buy Now</button>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProductCard",
    props: ["product"],
    computed: {
        discountPercentage() {
            const mrp = this.product.price;
            const offerPrice = this.product.offer_price;
            if (mrp > 0 && offerPrice < mrp) {
                const discount = ((mrp - offerPrice) / mrp) * 100;
                return discount.toFixed(0);
            } else {
                return 0;
            }
        }
    },
    methods: {
        openStoreURL() {
            window.open(this.product.store_url, "_blank");
        }
    }
};
</script>

<style>
.product-card_x {
    max-width: 30rem;
    min-height: 38rem;
    margin: 0 auto;
    padding: 2px;
    border: none;
    background: #fafafa;
    text-align: center;
    position: relative;
    padding-top: 2.4rem;
}

.product-card img {
    max-width: 100%;
    max-height: 200px;
    height: auto;
    margin-bottom: 10px;
    margin: 0;
}
.product-catagory {
    display: block;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    color: #ccc;
    margin-bottom: 12px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.product-card_x h2 {
    font-weight: 500;
    display: block;
    text-transform: uppercase;
    color: #363636;
    text-decoration: none;
    transition: 0.3s;

    margin-bottom: 10px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.product-card_x p {
    font-size: 14px;
    margin-bottom: 10px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.product-card_x .price-container {
    overflow: hidden;
    padding: 0.8rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    flex-grow: 1;
}
.product-card_x .price {
    margin-bottom: 10px;
    font-size: 15px;
    font-weight: 600;
}
.badge {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: red;
    color: white;
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 12px;
    font-weight: bold;
}

.product-card_x button {
    width: 100%;
    background-color: #66b0ff;
    color: white;
    border: none;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    border-radius: 5px;
    cursor: pointer;
    white-space: nowrap;
}
.discount {
    padding: 2px 5px;
    color: #000;
    font-weight: bold;
    background-color: #ff8080;
    border-radius: 5px;
}
.strikethrough {
    text-decoration: none;
    position: relative;
}
.strikethrough::before {
    content: "";
    width: 100%;
    position: absolute;
    right: 0;
    top: calc(50% - 1px);
    border-bottom: 1px solid #000;
}
.price-section {
    width: 100%;
    display: flex;
    justify-content: space-between;
}
@media (max-width: 1200px) {
    .product-card .price-container {
        flex-wrap: nowrap;
    }
}

@media (max-width: 768px) {
    .product-card_x {
        display: flex;
        flex-direction: column;
        width: calc(100% - 5px);
        max-width: none;
        min-width: 0;
        margin-bottom: 20px;
    }

    .product-card img {
        min-width: 0;
    }

    .price-section {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ProductCard.vue